export const LayoutExcludedRoutes = {
  LOGIN: '/login',
  HOME: '/',
}
